export const parsePaymentConfiguration = (value) => {
  if (!value) return null;
  if (typeof value === 'object') return value;
  if (typeof value !== 'string') return null;

  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

// El modelo real usa paymentConfig.enabled como interruptor explícito. Un
// importe de cero puede pertenecer a un sistema de pago gratuito/exento.
export const hasPaymentConfiguration = (poll) => {
  const config = parsePaymentConfiguration(poll?.paymentConfig);
  return config?.enabled === true || config?.enabled === 1 || config?.enabled === '1';
};

